import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  from as fromPromise } from 'rxjs';

import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { environment } from 'environments/environment';
import { nanoid } from 'nanoid';

import DesktopConfig from 'modules/desktop/services/config';
import { StudentBookService as DesktopStudentBookService } from 'modules/desktop/services/student-book.service';
import { UserdataService } from 'modules/desktop/services/userdata.service';
import { ProductEntitlementsService } from 'modules/desktop/services/product-entitlements.service';
import { HelperService } from 'modules/desktop/services/helper.service';
import { DownloadHelperService } from 'modules/desktop/services/download-helper.service';
import { EbookHelperService } from 'modules/desktop/services/ebook-helper.service';
import { AuthService } from 'modules/app/services/auth.service';
import $ from "jquery";

@Injectable()
export class StudentBookService {
    flattenedJSON
    private _isEbookInView:boolean = false;
    private entitlements;
    private schoolEntitlements;
    constructor(private http: HttpClient, 
        private apiGatewayHelperService: ApiGatewayHelperService,
        private desktopStudentBookService: DesktopStudentBookService,
        private userdataService: UserdataService,
        private productEntitlementsService: ProductEntitlementsService,
        private helperService: HelperService,
        private downloadHelperService: DownloadHelperService,
        private readonly ebookHelperService: EbookHelperService,
        public authService: AuthService,
    ) { }
    
    // TODO : Update this for desktop app to use mobile-gateway and return user spaces as well, works for webapp.
    public getStudentBook(spaceId, productCode, studentBookCode, classId, queryParams?): Observable<any> {

        if(environment.isDesktopApp){
            return fromPromise(
                new Promise((resolve, reject) => {
                    let user = this.userdataService.getLoggedInUser();
                    Promise
                        .all([
                            this.desktopStudentBookService.getUserSpaces(user),
                            this.productEntitlementsService.fetchModifiedAndSavedEntitlementsOfUser(user)
                        ])
                        .then(([userSpaces, userEntitlements]) => {
                            let { productUmbrella, downloadDetails } = this.desktopStudentBookService.getProductInfo(studentBookCode);
                            let product = productUmbrella.products.find((productData) => productData['dls-product'].code == studentBookCode);
                            let ebookpath = 'product/' + productUmbrella['bundle-code'] + '/studentbook/' + product['dls-product'].code + '/view';;
                            if (downloadDetails.downloaded && !this.downloadHelperService.autoUpdateStatus[product['dls-product'].code]) {
                                ebookpath = downloadDetails.location;
                                let bookPromise = new Promise((res, rej)=> {
                                    this.http.get(ebookpath + '/meta/definition_flat.json')
                                    .toPromise()
                                    .then((flattenedJSON: any) => {

                                        if(!flattenedJSON) {
                                            throw new Error(ERRORS.FILE_NOT_FOUND)
                                        }

                                        flattenedJSON.meta.paths = {
                                            "public-assets": `${ebookpath}/assets`,
                                            "json-flattened": `${ebookpath}/meta/definition_flat.json`
                                        };
                                        res(flattenedJSON);
                                    }).catch(err => {
                                        rej(err);
                                    });
                                });
                                let bookMetaPromise = new Promise((res, rej)=> {
                                    this.http.get(ebookpath + '/assets/imgbook-meta/book.json')
                                    .toPromise()
                                    .then((bookMeta: any) => {

                                        if(!bookMeta) {
                                            throw new Error(ERRORS.FILE_NOT_FOUND)
                                        }

                                        res(bookMeta);
                                    }).catch(err => {
                                        rej(err);
                                    });
                                });
                                let getBookOverlaysJSON = new Promise((res, rej)=> {
                                    this.http.get(ebookpath + '/assets/imgbook-meta/book-overlays.json')
                                    .toPromise()
                                    .then((bookOverlays: any) => {

                                        if(!bookOverlays) {
                                            throw new Error(ERRORS.FILE_NOT_FOUND)
                                        }
                                        
                                        res(bookOverlays);
                                    }).catch(err => {
                                        rej(err);
                                    });
                                });
                                let apiBookMetaPromise = this.ebookHelperService.getBookMeta(product['dls-product'].code);
                                Promise.all([bookPromise, bookMetaPromise, getBookOverlaysJSON, apiBookMetaPromise]).then((responses) => {
                                    let book:any  = responses[0];
                                    if (responses[3]) {
                                        console.log('using meta from manifest');
                                        delete responses[3].paths;
                                        book.meta = responses[3];
                                        book.meta.paths = {
                                            "public-assets": `${ebookpath}/assets`,
                                            "json-flattened": `${ebookpath}/meta/definition_flat.json`
                                        };
                                    }
                                    book.meta["book-info"] = responses[1];
                                    book.overlays = responses[2];
                                    resolve({
                                        book: book,
                                        bundle: Object.assign(productUmbrella, { cover: productUmbrella.imageURL }),
                                        entitlements: ((userEntitlements && userEntitlements.data) || { entities: [] }),
                                        userSpaces: userSpaces.spaces
                                    });
                                    
                                }).catch(err => {
                                    reject(err);
                                })


                            } else {
                                this.http.get(DesktopConfig.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'product/' + productCode + '/ebook/' + studentBookCode)
                                    .toPromise()
                                    .then((res: any) => {
                                        
                                        res && res.bundle && res.bundle.products && res.bundle.products.forEach(product => {
                                            if(this.helperService.isProductExpired(product)) {
                                                product.isExpired = true;
                                            }
                                        });

                                        res.bundle && (res.bundle.cover = productUmbrella.imageURL);
                                        res.entitlements = ((userEntitlements && userEntitlements.data) || { entities: [] });
                                        res.userSpaces = userSpaces.spaces;
                                        resolve(res);
                                    })
                                    .catch(err => {
                                        reject(err);
                                    });
                            }
                        })
                        .catch(err => {
                            reject(err);
                        })
               })
            )
        }
        else{
            return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/foc/product/' + productCode + '/studentbook/' + studentBookCode, { classId: classId, ...(typeof queryParams.ltiGiId === 'string' && { lgid: queryParams.ltiGiId })});
        }
    }

    public getUserSpacesAndClasses(spaceId, dataNeeded) {
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/getUserSpacesAndClasses', {dataNeeded}).toPromise();
    }

    public getClassesPreference() {
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'getClassesPreference', {}).toPromise();
    }

    // fetch TOC data json from API and then return a final usable JSON
    public getUnits(studentBook, imageMapBySerial, imageMapByLabel) {
        const coverUnitObject: any = {
            "label" : "Cover",
            "name" : "Cover",
            "item-code": "cover",
            "hide" : true,
            "start" : 1,
            "start-label" : imageMapBySerial.pages["sno-to-label-map"][1],
            "items" : [],
            "image" : undefined, //imageMapBySerial["sno-to-images-map"][1]
            "id" : nanoid(16) //for creating unique HTML id
        };

        const firstPageSerial = imageMapByLabel.pages["label-to-sno-map"][studentBook.items.default[0].attribs["start-page-no"]];
        let end = coverUnitObject.start;
        for (let i = 1 ; i < firstPageSerial; i++) {
            if(!imageMapBySerial.pages["sno-to-label-map"][i].includes("_MOD")) {
                end = i;
                coverUnitObject.items.push({
                    "name" : coverUnitObject.name,
                    "image" : imageMapBySerial["sno-to-images-map"][i],
                    "serial" : i,
                    "label" : imageMapBySerial.pages["sno-to-label-map"][i]
                });
            }
        }
        coverUnitObject.end = end;
        coverUnitObject["end-label"] = imageMapBySerial.pages["sno-to-label-map"][end];

        let outputArray = [coverUnitObject];

        outputArray = studentBook.items.default.reduce((result, unit, index) => _addUnit(result, unit, index), outputArray);
        return outputArray;

        function _addUnit(result, unit, index) {
            var unitObject = {
                "label" : "Unit " + (index + 1),
                "name" : unit.name,
                "item-code": unit["item-code"],
                "start": imageMapByLabel.pages["label-to-sno-map"][unit.attribs["start-page-no"]],
                "end" : imageMapByLabel.pages["label-to-sno-map"][unit.attribs["end-page-no"]],
                "start-label" : unit.attribs["start-page-no"],
                "end-label" : unit.attribs["end-page-no"],
                "items" : [],
                "image" : undefined,
                "id" : nanoid(16) //for creating unique HTML id
            };

            unitObject.image = imageMapBySerial["sno-to-images-map"][unitObject.start];
            var itemsObj = {};
            if(unit.items && unit.items.length) {
                itemsObj = _prepareChildPages(unit.items, (index + 1));
            }

            for (let i = unitObject.start; i <= unitObject.end; i++) {
                if(itemsObj[i]) { 
                unitObject.items.push(itemsObj[i]);
                } else {
                    unitObject.items.push({
                        "name" : unitObject.name,
                        "image" : imageMapBySerial["sno-to-images-map"][i],
                        "serial" : i,
                        "label" : imageMapBySerial.pages["sno-to-label-map"][i]
                    });
                }
            }
            result.push(unitObject);
            return result;
        }


        function _prepareChildPages(items, prefix) {
        
            return items.reduce((result, item, index) => {
            let start = imageMapByLabel.pages["label-to-sno-map"][item["imgbook_unit"]["start-page-no"]];
            let end = imageMapByLabel.pages["label-to-sno-map"][item["imgbook_unit"]["end-page-no"]];
            for (let i = start; i <= end; i++) {
            result[i] = {
                "name" : item.name,
                "image" : imageMapBySerial["sno-to-images-map"][i],
                "serial" : i,
                "label" : imageMapBySerial.pages["sno-to-label-map"][i]
            };
            }
            return result;
        }, {});
        
        }
    }

    /**
     * Handles keyboard focus for the notes pin and associated kebab dropdown menu. 
     * - when focus is on a note's pin and the user presses Enter, the corresponding kebab dropdown menu is focused.
     * - if Shift + Tab is pressed while on the kebab dropdown menu, focus returns to the notes pin of the associated note.
     * - triggers the default tabbing behaviour when user moves out of the respective note tile.
     *
     * @param {string} noteId - The ID of the note whose focus behavior is being managed.
     */
    public NotesPinKeyDownHandler(noteId) {
        // shifts focus to the kebab menu of the note when notes pin is pressed.
        const kebabMenuButton = $(`#dropdownMenuButton-${noteId}`)[0];
        $(kebabMenuButton)?.focus();
        
        // shifts focus back to the notes pin when Shift+Tab is pressed on kebab menu
        $(document).on('keydown.kebabMenu', `#dropdownMenuButton-${noteId}`, (event) => {
            if (event.shiftKey && event.key === 'Tab') {
                event.preventDefault();
                const notePinDiv = $(`[note-id="${noteId}"].customHotspotClass`).children()[0];
                $(notePinDiv)?.focus();
            }
        });
        
        // restore default tabbing behavior when tabbing through other notes or elements in the notes panel
        const singleNoteTile = $(`#single-note-${noteId}`);
        $(singleNoteTile).on('focusout', () => {
            setTimeout(() => {
                const activeElement = $(document.activeElement)[0];
                if (singleNoteTile.find(activeElement).length === 0) {
                    $(document).off('keydown.kebabMenu');
                    $(singleNoteTile).off('focusout');
                }
            }, 0);
        });
    }

    // if ebook is hidden or coming soon, redirect back to dashboard app
    // if space is mqa or visibilty is true(undefined for old products), then do not redirect
    public checkIfBookVisible(bundle, spaceId, spaces) {
        let isMQA = spaceId.indexOf("mqa") === 4;

        if(isMQA) return true;
        if( (spaceId.indexOf("user") === 0) && this.checkIfAnySpaceIsMQA(spaces)) return true;
        if(bundle && bundle.meta == undefined) return true;
        if(bundle && bundle.meta && bundle.meta.visibility == undefined) return true;
        if(bundle.meta.visibility == 'true') return true;
        return false;
    }

    checkIfAnySpaceIsMQA(spaces) {
        let isMQA = false;
        spaces.entities.forEach(entity => {
            // spaceid is of the form 'org_mqa-sierra-thor'.
            if (entity.space_key.indexOf("mqa") === 4) {
                isMQA = true;
            }
        });
        return isMQA;
    }

    /**
     * Determines whether a given product is active for the current user based on their role,
     * entitlements, and the product's activation settings.
     *
     * @param product - The product object to check for activation status. It is expected to have
     *                  an `activation` property containing `free` and `gated` activation settings
     *                  for different user roles, and a `dls-product` property with a `code`.
     * @param entitlements - Optional. An object containing user entitlements. If not provided,
     *                      the service's `entitlements` property will be used.
     * @param schoolEntitlements - Optional. An object containing school entitlements. If not provided,
     *                      the service's `schoolEntitlements` property will be used.
     * 
     * @returns `true` if the product is active for the user, otherwise `false`.
     *
     * The method evaluates the following conditions:
     * - If the product has free activation for the user's role, it is considered active.
     * - If the product has gated activation for the user's role, it is considered active only if
     *   the user or their school has an entitlement for the product.
     * - If the product does not have free activation, it checks if the user's or school's entitlement
     *   for the product has expired. If expired, the product is considered inactive.
     */
    isProductActive(product, entitlements = null, schoolEntitlements = null) {
        const userData = this.authService.getUserData();
        const userRole = userData.role === "student" ? "student" : "teacher";
        const resolvedUserEntitlements = entitlements ?? this.entitlements;
        const resolvedSchoolEntitlements = schoolEntitlements ?? this.schoolEntitlements;

        const isFreeActivation = product.activation.free[userRole];
        const isGatedActivation = product.activation.gated[userRole];
        const userEntitlement = resolvedUserEntitlements?.entities?.find(ent => ent.productcode === product['dls-product'].code);
        const schoolEntitlement = resolvedSchoolEntitlements?.entities?.find(ent => ent.productcode === product['dls-product'].code);
		const bypassEntitlementCheckforLTI = (userRole == 'teacher' && userData.launchType == 'lti');

        if (!isFreeActivation) {
            if (userEntitlement && userEntitlement.entitlement.end_date < Date.now()) {
                return false;
            }
            if (schoolEntitlement && schoolEntitlement.enddate < Date.now()) {
                return false;
            }
        }

        if (bypassEntitlementCheckforLTI || isFreeActivation || (isGatedActivation && (userEntitlement || schoolEntitlement))) {
            return true;
        }

        return false;
    }

    public set bookData(data) {
        this.entitlements = data.entitlements;
        this.schoolEntitlements = data.schoolEntitlements;
    }

    public get isEbookInView(){
        return this._isEbookInView;
    }

    public set isEbookInView(state){
        this._isEbookInView = state;
    }
}

enum ERRORS {
    FILE_NOT_FOUND = "FILE_NOT_FOUND"
}